import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const SuperAdminDashboardDefault = Loadable(lazy(() => import('views/SuperAdminDashboard/Default')));
const ViewAdministrator = Loadable(lazy(() => import('views/Administrator/ViewAdministrator')));
const StudentManagement = Loadable(lazy(() => import('views/SuperAdminDashboard/Student_Management')));
const ComplaintManagement = Loadable(lazy(() => import('views/SuperAdminDashboard/Complaint_Management')));
const RoomAllocation = Loadable(lazy(() => import('views/SuperAdminDashboard/Room_Allocation')));
const BuildingManagement = Loadable(lazy(() => import('views/SuperAdminDashboard/Building_Management')));
const BookingRequest = Loadable(lazy(() => import('views/SuperAdminDashboard/Booking_Request')));
const StudentAttendance = Loadable(lazy(() => import('views/SuperAdminDashboard/StudentAttendance')));
const StudentDetails = Loadable(lazy(() => import('views/SuperAdminDashboard/Student_Management/Student_details')));
const RoomAllotment = Loadable(lazy(() => import('views/SuperAdminDashboard/Room_Allotment/page')));
const Reports = Loadable(lazy(() => import('views/SuperAdminDashboard/Reports')));
const GatePass = Loadable(lazy(() => import('views/SuperAdminDashboard/GatePass')));
const HospitalComplaint = Loadable(lazy(() => import('views/SuperAdminDashboard/Hospital_Complaint')));
const HospitalComplaintRaise = Loadable(lazy(() => import('views/SuperAdminDashboard/Hospital_Complaint_Raise')));

const Fees_Management = Loadable(lazy(() => import('views/SuperAdminDashboard/StudentFee_Managment')));
const FeeUpload = Loadable(lazy(() => import('views/SuperAdminDashboard/FeeUpload')));

const FeeReport = Loadable(lazy(() => import('views/SuperAdminDashboard/FeeReports')));


// const StudentAdmission = Loadable(lazy(() => import('views/SuperAdminDashboard/Student_Admission')));
// const AdmissionForm = Loadable(lazy(() => import('views/SuperAdminDashboard/Student_Admission/AdmissionForm')));
// const EnquiryManagement = Loadable(lazy(() => import('views/SuperAdminDashboard/Enquiry_Management')));
// const EnquiryForm = Loadable(lazy(() => import('views/SuperAdminDashboard/Enquiry_Management/EnquiryForm')));


const FeeApproval = Loadable(lazy(() => import('views/SuperAdminDashboard/FeeApproval')));

// ==============================|| MAIN ROUTING ||============================== //

const SuperAdminRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <SuperAdminDashboardDefault />
    },
    {
      path: 'superadmindashboard',
      children: [
        {
          path: 'default',
          element: <SuperAdminDashboardDefault />
        },
        {
          path: 'buildingmanagement',
          element: <BuildingManagement />
        },

        {
          path: 'administrator/view/:id',
          element: <ViewAdministrator />
        },

        {
          path: 'studentmanagement',
          element: <StudentManagement />
        },
        {
          path: 'fees_management',
          element: <Fees_Management />
        },
        {
          path: 'fees_approval',
          element: <FeeApproval />
        },
        {
          path: 'fees_upload',
          element: <FeeUpload />
        },
        {
          path: 'fees_repots',
          element: <FeeReport />
        },
        {
          path: 'complaintmanagement',
          element: <ComplaintManagement />
        },
        {
          path: 'studentattendance',
          element: <StudentAttendance />
        },
        {
          path: 'studentmanagement/studentdetails/:id',
          element: <StudentDetails />
        },
        {
          path: 'roomallotment',
          element: <RoomAllotment />
        },
        {
          path: 'roomallocation',
          element: <RoomAllocation />
        },
        {
          path: 'booking_request',
          element: <BookingRequest />
        },
        {
          path: 'reports',
          element: <Reports />
        },
        {
          path: 'gatePass',
          element: <GatePass />
        },
        {
          path: 'hospital_complaint',
          element: <HospitalComplaint />
        },
        {
          path: 'hospital_complaint_raise',
          element: <HospitalComplaintRaise />
        },
        {
          path: 'fees_management',
          element: <Fees_Management />
        },
        // {
        //   path: 'admission_management',
        //   element: <StudentAdmission />
        // },
        // {
        //   path: 'admission_form',
        //   element: <AdmissionForm />
        // },
        // {
        //   path: 'enqury_management',
        //   element: <EnquiryManagement />
        // },
        // {
        //   path: 'enqury_form',
        //   element: <EnquiryForm />
        // }
      ]
    }
  ]
};

export default SuperAdminRoutes;
